import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Liens de préservation vérifiés pour un jeu (public).
export const getRescueLinks = (appId) => axios.get(`${API_BASE_URL}/rescue/${appId}`);

// Proposition d'un visiteur (créée en modération).
export const suggestRescueLink = (payload) => axios.post(`${API_BASE_URL}/rescue/suggest`, payload);
